export default __webpack_public_path__ + "static/media/minus.a02d98ca.svg";